// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
}

/* Upper Section */
.image-container {
  display: flex;
  gap: 80px;
  margin-bottom: 80px;
}

.image-box {
  width: 50rem;
  height: 30rem;
  background-color: #d1d1d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #444;
}

/* Bottom Section */
.bottom-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 1200px;
}

.box {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-height: 250px;
  overflow-y: auto;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

button {
  background: #000000;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
}

button:hover {
  background: #303030;
}

.select {
  width: 30%;
  height: 25px;
  border: transparent;
}

/* Console Box */
.console {
  margin-top: 10px;
  background: #eee;
  padding: 10px;
  height: 150px;
  overflow-y: auto;
  font-size: 14px;
  border-radius: 5px;
  color: #333;
  display: flex;
  flex-direction: column;
}

.log-entry {
  display: block;
  margin-bottom: 1px;
  font-family: monospace;
}

/* Responsive Design */
@media (max-width: 768px) {
  .image-container {
    flex-direction: column;
  }
  
  .bottom-section {
    grid-template-columns: 1fr;
  }
}

/* Image Upload Section */
.processed-images-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 100%;
  max-height: 450px;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

/* Dashboard Layout */
.dashboard-root {
  display: flex;
  height: 100vh;
  background: #f5f5f5;
  flex-direction: column;
}

.dashboard-topbar {
  width: 100%;
  height: 60px;
  background: #222;
  color: #fff;
  display: flex;
  align-items: center;
  padding-left: 240px; /* Sidebar width */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}

.dashboard-title {
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 2px;
  margin-left: 12px;
}

.dashboard-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 100vh;
  background: #fff;
  box-shadow: 2px 0 8px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 20;
  padding-top: 12px;
}

.dashboard-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  margin-bottom: 40px;
  align-self: center;
}

.logo-text {
  font-size: 2rem;
  font-weight: bold;
  color: #222;
}

.dashboard-nav {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px;
}

.dashboard-nav button {
  background: #222;
  color: #fff;
  border: none;
  padding: 12px 10px;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s;
}

.dashboard-nav button:hover {
  background: #444;
}

.dashboard-language {
  padding: 20px;
  border-top: 1px solid #eee;
  margin-bottom: 20px;
}

.dashboard-language label {
  margin-right: 8px;
  font-size: 1rem;
}

.dashboard-language select {
  padding: 4px 8px;
  font-size: 1rem;
}

.dashboard-content {
  margin-left: 240px;
  margin-top: 60px;
  padding: 0 40px 0 40px;
  min-height: calc(100vh - 60px);
  /* Add your main content styles here */
}

.dashboard-new-project {
  position: fixed;
  right: 32px;
  bottom: 32px;
  background: #222;
  color: #fff;
  padding: 16px 28px;
  border-radius: 32px;
  font-size: 1.1rem;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  cursor: pointer;
  z-index: 100;
  transition: background 0.2s, transform 0.2s;
}
.dashboard-new-project:hover {
  background: #444;
}

/* Dashboard table */
.projects-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: #fff;
}

.projects-table th, .projects-table td {
  border: 1px solid #eee;
  padding: 12px 16px;
  text-align: left;
}

.projects-table th {
  background: #f5f5f5;
  font-weight: bold;
}

/* Login styles */
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-center {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  background: #fff;
  padding: 32px 40px;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 320px;
}

.login-title {
  text-align: center;
  margin-bottom: 10px;
}

.login-input {
  width: 95%;
  padding: 8px;
  margin-top: 4px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

.login-link {
  text-decoration: none;
  color: #000000;
}

.login-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
}

.login-button {
  background: #000000;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
  transition: background 0.2s;
}

.login-button:hover {
  background: #303030;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE,kBAAkB;EACvC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100vh;\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n/* Upper Section */\n.image-container {\n  display: flex;\n  gap: 80px;\n  margin-bottom: 80px;\n}\n\n.image-box {\n  width: 50rem;\n  height: 30rem;\n  background-color: #d1d1d1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: #444;\n}\n\n/* Bottom Section */\n.bottom-section {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.box {\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton {\n  background: #000000;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\nbutton:hover {\n  background: #303030;\n}\n\n.select {\n  width: 30%;\n  height: 25px;\n  border: transparent;\n}\n\n/* Console Box */\n.console {\n  margin-top: 10px;\n  background: #eee;\n  padding: 10px;\n  height: 150px;\n  overflow-y: auto;\n  font-size: 14px;\n  border-radius: 5px;\n  color: #333;\n  display: flex;\n  flex-direction: column;\n}\n\n.log-entry {\n  display: block;\n  margin-bottom: 1px;\n  font-family: monospace;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .image-container {\n    flex-direction: column;\n  }\n  \n  .bottom-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Image Upload Section */\n.processed-images-gallery {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: 100%;\n  max-height: 450px;\n  overflow-y: auto;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n/* Dashboard Layout */\n.dashboard-root {\n  display: flex;\n  height: 100vh;\n  background: #f5f5f5;\n  flex-direction: column;\n}\n\n.dashboard-topbar {\n  width: 100%;\n  height: 60px;\n  background: #222;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  padding-left: 240px; /* Sidebar width */\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n\n.dashboard-title {\n  font-size: 2rem;\n  font-weight: bold;\n  letter-spacing: 2px;\n  margin-left: 12px;\n}\n\n.dashboard-sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 240px;\n  height: 100vh;\n  background: #fff;\n  box-shadow: 2px 0 8px rgba(0,0,0,0.05);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  z-index: 20;\n  padding-top: 12px;\n}\n\n.dashboard-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 20px;\n  margin-bottom: 40px;\n  align-self: center;\n}\n\n.logo-text {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #222;\n}\n\n.dashboard-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 20px;\n}\n\n.dashboard-nav button {\n  background: #222;\n  color: #fff;\n  border: none;\n  padding: 12px 10px;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s;\n}\n\n.dashboard-nav button:hover {\n  background: #444;\n}\n\n.dashboard-language {\n  padding: 20px;\n  border-top: 1px solid #eee;\n  margin-bottom: 20px;\n}\n\n.dashboard-language label {\n  margin-right: 8px;\n  font-size: 1rem;\n}\n\n.dashboard-language select {\n  padding: 4px 8px;\n  font-size: 1rem;\n}\n\n.dashboard-content {\n  margin-left: 240px;\n  margin-top: 60px;\n  padding: 0 40px 0 40px;\n  min-height: calc(100vh - 60px);\n  /* Add your main content styles here */\n}\n\n.dashboard-new-project {\n  position: fixed;\n  right: 32px;\n  bottom: 32px;\n  background: #222;\n  color: #fff;\n  padding: 16px 28px;\n  border-radius: 32px;\n  font-size: 1.1rem;\n  font-weight: bold;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n  cursor: pointer;\n  z-index: 100;\n  transition: background 0.2s, transform 0.2s;\n}\n.dashboard-new-project:hover {\n  background: #444;\n}\n\n/* Dashboard table */\n.projects-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  background: #fff;\n}\n\n.projects-table th, .projects-table td {\n  border: 1px solid #eee;\n  padding: 12px 16px;\n  text-align: left;\n}\n\n.projects-table th {\n  background: #f5f5f5;\n  font-weight: bold;\n}\n\n/* Login styles */\n.login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.login-center {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-form {\n  background: #fff;\n  padding: 32px 40px;\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  min-width: 320px;\n}\n\n.login-title {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.login-input {\n  width: 95%;\n  padding: 8px;\n  margin-top: 4px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n}\n\n.login-link {\n  text-decoration: none;\n  color: #000000;\n}\n\n.login-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1rem;\n}\n\n.login-button {\n  background: #000000;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-top: 10px;\n  transition: background 0.2s;\n}\n\n.login-button:hover {\n  background: #303030;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
